<template>
  <div class="shouye-center-b">
    <div class="sy-b-top">
        <h2>Sub Brand</h2>
        <div class="sy-b-top-box">
            <span>旗下品牌</span>
        </div>
    </div>
    <div class="sy-b-center">
        <div class="triangle-topleft" id="triangle-topleft">
        </div>
        <div class="triangle-topleft" id="triangle-topleft2">
        </div>
                                <div class="sy-b-center-a ">
            <div class="sy-b-center-a-img">
                <a href="/brand">
                    <img src="@s/data/uploads/20180727/0d21510f4c349febccfca18ba41a4762.png" />
                </a>
            </div>
            <div class="sy-b-center-a-imglogo">
                <a href="/brand">
                    <img src="@s/data/uploads/20180727/b0066846b2cc929a665e2ceb7fecd468.png" />
                </a>
            </div>
        </div>
                                <div class="sy-b-center-a  sy-b-center-b">
            <div class="sy-b-center-a-img">
                <a href="/brand/1">
                    <img src="@s/data/uploads/20180727/f6a96b342cc9d9cbca8f820f17c6d249.png" />
                </a>
            </div>
            <div class="sy-b-center-a-imglogo">
                <a href="/brand/1">
                    <img src="@s/data/uploads/20180727/618cef496bc62f2511e8134f08b42349.png" />
                </a>
            </div>
        </div>
                                <div class="sy-b-center-a ">
            <div class="sy-b-center-a-img">
                <a href="/brand/2">
                    <img src="@s/data/uploads/20191024/0a7df3c5510e8fa363b8fbbbf39f5cb0.png" />
                </a>
            </div>
            <div class="sy-b-center-a-imglogo">
                <a href="/brand/2">
                    <img src="@s/data/uploads/20191024/a1c13d535a4a1e428f9f4202986b5ce1.png" />
                </a>
            </div>
        </div>
                                <div class="sy-b-center-a  sy-b-center-b">
            <div class="sy-b-center-a-img">
                <a href="/brand/3">
                    <img src="@s/data/uploads/20191008/b1177514b930069abdd2af8e6acc67eb.png" />
                </a>
            </div>
            <div class="sy-b-center-a-imglogo">
                <a href="/brand/3">
                    <img src="@s/data/uploads/20191008/b62479acd42d7c734c36a036a5d01ab4.png" />
                </a>
            </div>
        </div>
                            </div>

    <div class="aaa" style="display:none;"  v-if="advertisingVideo">
        <div class="bi">
            <img src="@s/skin/web/img/index/guanbi.png"  style="width: 100%; height: 100%;">
        </div>
        <video id="oVideo" preload class="Video" :poster="advertisingVideo.image">
        <source :src="advertisingVideo.video" type="video/mp4" />
            <source :src="advertisingVideo.video" type="video/ogg" />
            <source :src="advertisingVideo.video" type="video/webm" />
            <object width="100%;" height="" type="application/x-shockwave-flash" data="myvideo.swf">
                    <param name="movie" value="myvideo.swf" />
                    <param name="flashvars" value="autostart=true&amp;file=myvideo.swf" />
                </object> 当前浏览器不支持 video直接播放，点击这里下载视频：
            <a href="myvideo.webm">下载视频</a>
        </video>
    </div>
    <div class="sy-b-footer" v-if="advertisingVideo">
        <video id="oVideo"  :poster="advertisingVideo.image">
            <source :src="advertisingVideo.video" type="video/mp4" />
            <source :src="advertisingVideo.video" type="video/ogg" />
            <source :src="advertisingVideo.video" type="video/webm" />
            <object width="100%;" height="" type="application/x-shockwave-flash" data="myvideo.swf">
                    <param name="movie" value="myvideo.swf" />
                    <param name="flashvars" value="autostart=true&amp;file=myvideo.swf" />
                </object> 当前浏览器不支持 video直接播放，点击这里下载视频：
            <a href="myvideo.webm">下载视频</a>
        </video>
        <div class="sy-b-tu">
            <img id="oStart" src="@s/skin/web/img/index/bofang.png" />
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "B",
  data() {
    return {
        advertisingVideo: this.$store.state.advertisingVideo
    };
  },
  methods:{
    initVideo(){
        var b = document.documentElement.clientHeight
        $(".aaa").css("height", b)
        $(".bi").click(function() {
            $('.sy-b-tu').show();
            $(this).find('img').show();
            current = true;
            $(".sy-b-footer").show()
            $(".aaa").hide()
        })

        //视频播放
        var oVideo = document.getElementById("oVideo");
        this.controls = true; //控制条
        var current = true;
         $("#oStart").unbind('click')
        $("#oStart").on('click', function() {
            if(current) {
                oVideo.play();
                $('.sy-b-tu').css("display", "none");
                $(this).find('img').hide();
                current = false;
                $("#oVideo").attr("controls", "controls");
                $(".aaa").show()
            } else {
                oVideo.pause();
                $(this).find('img').hide();
                current = true
            }
            var _this = $(this);
            oVideo.addEventListener("ended", function() {
                _this.find('img').show();
            })
        })
    }
  },
  watch:{
    '$store.state.advertisingVideo'(val){
        this.advertisingVideo = val
        this.$nextTick(() => {
            this.initVideo()
        })
    }
  },
  mounted(){
    
        $("#triangle-topleft").on('mouseenter', function() {
            $(this).siblings(".sy-b-center-a").eq(0).children(".sy-b-center-a-img").hide()
            $(this).siblings(".sy-b-center-a").eq(0).children(".sy-b-center-a-imglogo").show()
        }).on('mouseleave', function() {
            $(this).siblings(".sy-b-center-a").eq(0).children(".sy-b-center-a-img").show()
            $(this).siblings(".sy-b-center-a").eq(0).children(".sy-b-center-a-imglogo").hide()
        })

        $("#triangle-topleft2").on('mouseenter', function() {
            $(this).siblings(".sy-b-center-a").eq(2).children(".sy-b-center-a-img").hide()
            $(this).siblings(".sy-b-center-a").eq(2).children(".sy-b-center-a-imglogo").show()
        }).on('mouseleave', function() {
            $(this).siblings(".sy-b-center-a").eq(2).children(".sy-b-center-a-img").show()
            $(this).siblings(".sy-b-center-a").eq(2).children(".sy-b-center-a-imglogo").hide()
        })
        if(this.advertisingVideo){
            this.initVideo()
        }
        
  }
}
</script>
